import { connect } from "react-redux";
import useQueryParams from "../../customHooks/useQueryParams";
import { Helmet } from "react-helmet-async";
import { Card, CardBody, Col, Container, FormGroup, Label, Row, Spinner } from "reactstrap";

import ButtonCustom from "../../components/Buttons/ButtomCustom";
import { Controller, useForm } from "react-hook-form";
import { cleanMessageTemplate, getTemplate, getTemplateHistory, loadEmptyTemplate, saveTemplate, } from "../../store/actions";
import { useEffect, useRef } from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { setValuesHookForm } from "../../helpers/load_object_hook_form";
import { fieldsMessage } from "../../helpers/utils/fieldsMessage";
import Select from "react-select";
import MonacoEditor from "../../components/MonacoEditor/MonacoEditor";
import { useNavigate } from "react-router-dom";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import { useContextActions } from "../../customHooks/useContextActions";
import useAlert from "../../customHooks/useAlert";

const TemplateDetail = ({
    template,
    loadingTemplate,
    messageTemplate,
    isTemplateSave,
    saveTemplateRequest,
    getTemplateRequest,
    loadEmptyTemplate,
    cleanMessageTemplate,
    getTemplateHistoryRequest,
    errorLoadingTemplate,
	errorLoadingTemplateHistory,
}) => {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        setValue,
    } = useForm({
        defaultValues: {
            active: true,
        }
    });
    
    const alertModal = withReactContent(Swal);
    const { confirmAlert } = useAlert();
    const navigate = useNavigate();
    const params = useQueryParams();
    const id = params.get("id");
    const idHistory = params.get("idHistory");
    const hasInteracted = useRef(false);
    const initialContentRef = useRef(null);
    const hasInitializedContent = useRef(false);
    function handleBack() {
        loadEmptyTemplate();
        navigate("/templates");
    }
    async function handleSave(values) {
        const isEdit= id !== null;
        const baseBody = {
            title: values.title, 
            active: values.active,
            description: values.description,
            content: values.content,
            idLogo: values.idLogo,
        };
        const body = isEdit ? { id, ...baseBody } : baseBody;
        
        if(isEdit) {
            const result = await confirmAlert("Attention! All documents associated with this Template will be updated to Draft status. Do you want to continue?")

            if(!result.isConfirmed) return;
        }

        await saveTemplateRequest({
            body,
            method: isEdit ? "PUT" : "POST",
        });
    }

		const actions = useContextActions({
			context: "template",
			screen: "detail",
		});
		const editableWithSave = actions.some(e => e === "save")

    useEffect(() => {
        
        if (id !== null) {
            getTemplateRequest({ templateId: id });
        } else if (idHistory !== null) {
            getTemplateHistoryRequest({ idHistory: idHistory });
        } else {
            getTemplateRequest({ templateId: null });
        }
        
        return () => {
            loadEmptyTemplate();
            cleanMessageTemplate();
        }
        // eslint-disable-next-line
    },[]);
    useEffect(() => {
        if (isTemplateSave !== null) {
            alertModal
                .fire({
                title: isTemplateSave === true ? `Template ${id === null ? "created" : "updated"} successfully!` : `${messageTemplate !== null ? messageTemplate : "Something wrong, try again later."}`,
                icon: isTemplateSave === true ? "success" : "error",
                showConfirmButton: false,
                showCloseButton: true,
                timer: isTemplateSave === true ? 2000 : undefined,
                timerProgressBar: isTemplateSave === true ? true : false,
            }).then((result) => {
                if(isTemplateSave) {
                    if (result.dismiss) {
                        cleanMessageTemplate();
                        navigate("/templates");
                    }
                }
            
                if(result.dismiss) {
                    cleanMessageTemplate();
                }
            });
        }

        // eslint-disable-next-line
    },[isTemplateSave]);
    useEffect(() => {
        if (errorLoadingTemplate !== null) {
            alertModal
                .fire({
                    title: "Something wrong, try again later.",
                    icon: "error",
                    showConfirmButton: false,
                    showCloseButton: true,
                    allowOutsideClick: false,
                    //timer: 2000,
                    //timerProgressBar: true,
                }).then((result) => {
                    if (errorLoadingTemplate) {
                        if (result.dismiss) {
                            cleanMessageTemplate();
                            loadEmptyTemplate();
                            navigate("/templates");
                        }
                    }
                    if (result.dismiss) {
                        cleanMessageTemplate();
                        loadEmptyTemplate();
                    }
                })
        }

        // eslint-disable-next-line
    }, [errorLoadingTemplate]);
    useEffect(() => {
        if (errorLoadingTemplateHistory !== null) {
            alertModal
                .fire({
                    title: "Something wrong, try again later.",
                    icon: "error",
                    showConfirmButton: false,
                    showCloseButton: true,
                    allowOutsideClick: false,
                    //timer: 2000,
                    //timerProgressBar: true,
                }).then((result) => {
                    if (errorLoadingTemplateHistory) {
                        if (result.dismiss) {
                            cleanMessageTemplate();
                            loadEmptyTemplate();
                            navigate("/templates");
                        }
                    }
                    if (result.dismiss) {
                        cleanMessageTemplate();
                        loadEmptyTemplate();
                    }
                })
        }

        // eslint-disable-next-line
    }, [errorLoadingTemplateHistory]);
    useEffect(() => {
        if (!template) return;
        
        setValuesHookForm(template, setValue);
        setValue("idLogo", template.logo?.value || null);
        setValue("active", template.active ?? true);
            
        if (!hasInitializedContent.current) {
          const initial = template.content ?? "";
          setValue("content", initial);
          initialContentRef.current = initial;
          hasInitializedContent.current = true;
        }
        // eslint-disable-next-line
    }, [template]);
    useEffect(() => {
        register("content", 
            { 
                required: "Content is required.",
                validate: (value) =>{
                    if(!value) return fieldsMessage.required("Content");
                    if(value.trim() === "") return fieldsMessage.required("Content");
                    return true;
            }});

    }, [register]);

    return (
        <div className="page-content">
            <Helmet>
                <title>Template</title>
            </Helmet>
            <Container fluid>
                <Row>
                    <Col xs={12}>
                        <Card>
                            <CardBody>
                                <div>
                                    <Row className="my-2">
                                        {loadingTemplate ? (
                                            <div
                                                className="d-flex align-items-center justify-content-center"
                                                style={{ height: "400px", width: "100%" }}
                                            >
                                                <Spinner
                                                    color="primary"
                                                    style={{ height: "5rem", width: "5rem" }}
                                                />
                                            </div>
                                        ) : (
                                            <>
                                            <form onSubmit={handleSubmit(handleSave)}>
                                                <div className="d-flex justify-content-between my-2">
                                                    <h2>
                                                        {id === null
                                                            ? idHistory === null
                                                            ? "CREATE"
                                                            : "VIEW"
                                                            : "EDIT"}{" "}
                                                        TEMPLATE
                                                    </h2>
                                                    <div className="d-flex gap-2 mb-4">
                                                        <ButtonCustom
                                                            type="cancel"
                                                            onClick={() => handleBack()}
                                                        />
																												<ActionButtons 
																													actions={actions}
																													handlers={{ 
																														save: handleSubmit(handleSave), 
																													}}
																												/>
                                                    </div>
                                                </div>
                                                
                                                <Row>
                                                    <Col md="4">
                                                        <FormGroup className="mb-3">
                                                            <Label
                                                                htmlFor="title"
                                                                className="label-detail-form"
                                                            >
                                                                Title
                                                            </Label>
                                                            <input
                                                                className="form-control"
                                                                id="title"
                                                                type="text"
                                                                disabled={(idHistory !== null) || (!editableWithSave)}
																																style={(idHistory !== null) || (!editableWithSave) ? {color: "#00000060"} : {}}
                                                                placeholder="Template title"
                                                                {...register("title", {
                                                                    required: fieldsMessage.required("Template title"),
                                                                    validate: (value) => value.trim() !== "" || fieldsMessage.required("Template title"),
                                                                    maxLength: {
                                                                        value: 100,
                                                                        message: fieldsMessage.maxLength("Template title", 100),
                                                                    }
                                                                })}
                                                            />
                                                            <p className="error-form">
                                                                {errors.title?.message}
                                                            </p>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4">
                                                        <FormGroup className="mb-3">
                                                            <Label
                                                                htmlFor="title"
                                                                className="label-detail-form"
                                                            >
                                                                Description
                                                            </Label>
                                                            <input
                                                                className="form-control"
                                                                id="description"
                                                                type="text"
                                                                disabled={(idHistory !== null) || (!editableWithSave)}
																																style={(idHistory !== null) || (!editableWithSave) ? {color: "#00000060"} : {}}
                                                                placeholder="Template description"
                                                                {...register("description")}
                                                            />
                                                        </FormGroup>            
                                                    </Col>
                                                    <Col md="4">
                                                        <Label className="label-detail-form">
                                                            Logo
                                                        </Label>
                                                        <Controller
                                                            id="idLogo"
                                                            name="idLogo"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <Select
                                                                    className="filter-select"
                                                                    isDisabled={(idHistory !== null) || (!editableWithSave)}
                                                                    options={template?.logosOptions || []} 
                                                                    value={ idHistory !== null ? template?.logo : (template?.logosOptions || []).find(o => o.value === field.value) || null }
                                                                    onChange={(option) => field.onChange(option?.value ?? null)}
                                                                    placeholder="Select Logo"
                                                                    isClearable
                                                                    styles={ idHistory !== null && {
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            backgroundColor: state.isDisabled ? "#eff2f7" : "#fff",
                                                                            borderColor: "#ced4da",
                                                                            cursor: state.isDisabled ? "not-allowed" : "default",
                                                                            opacity: state.isDisabled ? 1 : 1, 
                                                                            boxShadow: "none",
                                                                            "&:hover": {
                                                                                borderColor: "#ced4da"
                                                                            },
                                                                        }),
																																				
                                                                        singleValue: (base, state) => ({
                                                                            ...base,
                                                                            color: state.isDisabled ? "#495057" : "#495057", 
                                                                        }),
																																				
                                                                    }}
                                                                />
                                                            )}      
                                                        />
                                                    </Col>                                                    
                                                </Row>
                                                                                                
                                                <Row>
                                                    <Col md="3">
                                                        <FormGroup className="mb-3">
                                                            <Label
                                                                htmlFor="createUser"
                                                                className="label-detail-form"
                                                            >
                                                                Created By
                                                            </Label>
                                                            <input
                                                                className="form-control"
                                                                id="createUser"
                                                                {...register("createUser")}
                                                                disabled
																																style={{ color: '#00000060'}}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup className="mb-3">
                                                            <Label
                                                                id="createDate"
                                                                className="label-detail-form"
                                                            >
                                                                Creation Date
                                                            </Label>
                                                            <input
                                                                className="form-control"
                                                                name="createDate"
                                                                {...register("createDate")}
                                                                disabled
																																style={{ color: '#00000060'}}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup className="mb-3">
                                                            <Label
                                                                id="updateUser"
                                                                className="label-detail-form"
                                                            >
                                                                Updated By
                                                            </Label>
                                                            <input
                                                                className="form-control"
                                                                name="updateUser"
                                                                {...register("updateUser")}
                                                                disabled
																																style={{ color: '#00000060'}}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup className="mb-3">
                                                            <Label
                                                                id="updateDate"
                                                                className="label-detail-form"
                                                            >
                                                                Update Date
                                                            </Label>
                                                            <input
                                                                className="form-control"
                                                                name="updateDate"
                                                                {...register("updateDate")}
                                                                disabled
																																style={{ color: '#00000060'}}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                
                                                <Row className="my-2 mb-4">
                                                    <Col className="d-flex align-items-center">
                                                        <FormGroup>
                                                            <label htmlFor="active" className="label-check">
                                                                <input
                                                                    id="active"
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    disabled={(idHistory !== null) || (!editableWithSave)}
                                                                    {...register("active")}
                                                                />
                                                                Active Status
                                                            </label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col md="12">
                                                        <FormGroup className="mb-3">
                                                            <Label
                                                                htmlFor="content"
                                                                className="label-detail-form"
                                                            >
                                                                Content
                                                                <span className="error-form"> {errors.content?.message}</span>
                                                            </Label>
                                                            <MonacoEditor
                                                                handleEditorChange={(content) => {
                                                                    initialContentRef.current = content;
                                                                    setValue("content", content, {
                                                                        shouldValidate: hasInteracted.current,
                                                                        shouldDirty: true,
                                                                    });
                                                                    if (!hasInteracted.current) {
                                                                        hasInteracted.current = true;
                                                                    }
                                                                }}
                                                                language="html"
                                                                initialValue={hasInteracted.current ? initialContentRef.current ?? "" : (template?.content ?? "")}
                                                                loading={loadingTemplate}
                                                                isEditable={(idHistory !== null) || (!editableWithSave)}
                                                            />
                                                            <p className="error-form">
                                                                {errors.content?.message}
                                                            </p>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </form>
                                        </>
                                        )
                                        }
                                    </Row>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
};

const mapStateToProps = ({
    TemplateReducer: {
        template,
        loadingTemplate,
        messageTemplate,
        isTemplateSave,
        errorLoadingTemplate,
	    errorLoadingTemplateHistory,
    },
}) => ({
    template,
    loadingTemplate,
    messageTemplate,
    isTemplateSave,
    errorLoadingTemplate,
	errorLoadingTemplateHistory,
});

const mapDispatchToProps = {
    saveTemplateRequest: saveTemplate.request,
    getTemplateRequest: getTemplate.request,
    getTemplateHistoryRequest: getTemplateHistory.request,
    loadEmptyTemplate,
    cleanMessageTemplate,
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplateDetail);